<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>资金管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">杉泰发薪</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddShow && !hideInDetail">
      <section class="searchBox">
        <span>
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddShow = !hideInAddShow"
            >导入发薪表</a-button
          >
        </span>
        <span>
          <label>日期：</label>
          <a-date-picker v-model="date" @change="onChangeDate" />
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            v-model="query_field"
            style="width:200px"
            placeholder="请输入批次编号|姓名|手机号|openid|身份证号"
          />
        </span>
        <span>
          <a-button class="resetStyle" @click="downloadCost">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button @click="onReset" style="margin-right:10px">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.salary_date }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.idcard }}</td>
              <td>{{ item.bank_card_number }}</td>
              <td>{{ item.pre_amount }}</td>
              <td>{{ item.real_amount }}</td>
              <td>
                <a @click="detailPage(item)">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!--  增加 -->
    <batchAddSTPayment v-on:hideInAdd="hideInAdd" v-show="hideInAddShow" />
    <!--   增加 end -->
    <!-- 详情 -->
    <stPaymentDetail
      v-show="hideInDetail"
      :detailVal="detailVal"
      v-on:hideInDetailPage="hideInDetailPage"
    />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import batchAddSTPayment from "@/components/money/batchAddSTPayment"; //增加
import stPaymentDetail from "@/components/money/stPaymentDetail"; //详情
export default {
  components: {
    batchAddSTPayment,
    stPaymentDetail
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      thList: [
        "表格日期",
        "姓名",
        "手机号",
        "身份证号",
        "银行卡号",
        "应发金额",
        "实发金额",
        "操作"
      ],
      hideInDetail: false,
      start_date: "",
      end_date: "",
      date: null,
      detailVal: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    hideInDetailPage(msg) {
      this.hideInDetail = false;
      if (msg) {
        this.reload();
      }
    },
    detailPage(item) {
      this.hideInDetail = true;
      this.detailVal = item;
    },
    onChangeDate(date, dateString) {
      // console.log(dateString)
      this.start_date = dateString;
      this.end_date = dateString;
    },
    downloadCost() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "St_user/downloadSalaryList?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date;
    },
    onReset() {
      this.query_field = "";
      this.start_date = "";
      this.end_date = "";
      this.date = null;
      this.page = 1;
      this.getData();
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = false;
      this.reload();
    },
    showInUserList() {
      this.hideInAddShow = false;
      this.hideInDetail = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "St_user/uploadSalaryList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          start_date: this.start_date,
          end_date: this.end_date,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    padding: 14px 2%;
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      button {
        margin-left: 10px;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
